import React from 'react'
import { createSlice, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { getDefaultMiddleware } from '@reduxjs/toolkit';


const allUrl = {
    adminInfo: 'https://amirsabit.4api.ir/admin',
    adminResume: 'https://amirsabit.4api.ir/certificates',
    contactUsInfo: 'https://amirsabit.4api.ir/admin/view',
    portfolio: 'https://amirsabit.4api.ir/filters-default',
    blog: 'https://amirsabit.4api.ir/blog/index'
}

const initialState = {
    infoMe: null,
    status: 'idle',
    error: null,

    resume: null,
    resumeStatus: 'idle',
    resumeError: null,

    contact: null,
    contactStatus: 'idle',
    contactError: null,

    portfolio: null,
    portfolioStatus: 'idle',
    portfolioError: null,

    blogList: null,
    blogListStatus: 'idle',
    blogListoError: null,

    language: 'Fa',

    article: ''

}

export const fetchadminInfo = createAsyncThunk('resume/fetchadminInfo', async () => {
    localStorage.setItem("language", (initialState.language));
    try {
        const response = await axios.post(allUrl.adminInfo)
        return response.data.data
    } catch (error) {
        return error.message
    }
})

export const fetchadminResume = createAsyncThunk('resume/fetchadminResume', async () => {
    try {
        const response = await axios.post(allUrl.adminResume)
        return response.data.data
    } catch (error) {
        return error.message
    }
})

export const fetchContactUsInfo = createAsyncThunk('resume/fetchContactUsInfo', async () => {
    try {
        const response = await axios.post(allUrl.contactUsInfo)
        return response.data.data
    } catch (error) {
        return error.message
    }
})

export const fetchPortfolioIsotope = createAsyncThunk('resume/fetchPortfolioIsotope', async () => {
    try {
        const response = await axios.post(allUrl.portfolio)
        // console.log(response.data);
        return response.data.data
    } catch (error) {
        return error.message
    }
})

export const fetchBlogList = createAsyncThunk('resume/fetchBlogList', async () => {
    try {
        const response = await axios.post(allUrl.blog)
        // console.log(response.data);
        return response.data.data
    } catch (error) {
        // console.log(error.message);
        return error.message
    }
})

// export const fetcharticle = (state, action) => {
//     state.article = action.payload.article
// }


const ResumeSlice = createSlice({
    name: 'resume',
    initialState,

    reducers: {
        fetcharticle(state, action) {
            console.log(action.payload.article);
            state.article = action.payload.article
        }
    },

    extraReducers(builder) {
        builder

            .addCase(fetchadminInfo.pending, (state, action) => {
                // console.log("loading");
                state.status = 'loading'
            })
            .addCase(fetchadminInfo.fulfilled, (state, action) => {
                // console.log("succeeded");
                state.status = 'succeeded';
                state.infoMe = action.payload;
            })
            .addCase(fetchadminInfo.rejected, (state, action) => {
                // console.log("error");
                state.status = 'error';
                state.error = state.error.message
            })


            .addCase(fetchadminResume.pending, (state, action) => {
                // console.log("loading");
                state.resumeStatus = 'loading'
            })
            .addCase(fetchadminResume.fulfilled, (state, action) => {
                // console.log("succeeded");
                state.resumeStatus = 'succeeded';
                state.resume = action.payload;
            })
            .addCase(fetchadminResume.rejected, (state, action) => {
                // console.log("error");
                state.resumeStatus = 'error';
                state.resumeError = state.error.message
            })


            .addCase(fetchContactUsInfo.pending, (state, action) => {
                // console.log("loading");
                state.contactStatus = 'loading'
            })
            .addCase(fetchContactUsInfo.fulfilled, (state, action) => {
                // console.log("succeeded");
                state.contactStatus = 'succeeded';
                state.contact = action.payload;
            })
            .addCase(fetchContactUsInfo.rejected, (state, action) => {
                // console.log("error");
                state.contactStatus = 'error';
                state.contactError = state.error.message
            })



            .addCase(fetchPortfolioIsotope.pending, (state, action) => {
                // console.log("loading");
                state.portfolioStatus = 'loading'
            })
            .addCase(fetchPortfolioIsotope.fulfilled, (state, action) => {
                // console.log("succeeded");
                state.portfolioStatus = 'succeeded';
                state.portfolio = action.payload;
            })
            .addCase(fetchPortfolioIsotope.rejected, (state, action) => {
                // console.log("error");
                state.portfolioStatus = 'error';
                state.portfolioError = state.error.message
            })


            .addCase(fetchBlogList.pending, (state, action) => {
                // console.log("loading");
                state.blogListStatus = 'loading'
            })
            .addCase(fetchBlogList.fulfilled, (state, action) => {
                // console.log("succeeded");
                state.blogListStatus = 'succeeded';
                state.blogList = action.payload;
            })
            .addCase(fetchBlogList.rejected, (state, action) => {
                // console.log("error");
                state.blogListStatus = 'error';
                state.blogListoError = state.error.message
            })


    }
})


export const selectAllInfoMe = (state) => state.adminInfooo.infoMe
export const getCvStatus = (state) => state.adminInfooo.status
export const getCvErrors = (state) => state.adminInfooo.error;


export const selectAllResume = (state) => state.adminInfooo.resume
export const getResumeStatus = (state) => state.adminInfooo.resumeStatus
export const getResumeErrors = (state) => state.adminInfooo.resumeError;


export const selectContactUsInfo = (state) => state.adminInfooo.contact
export const getContactUsStatus = (state) => state.adminInfooo.contactStatus
export const getContactUsErrors = (state) => state.adminInfooo.contactError;


export const selectportfolio = (state) => state.adminInfooo.portfolio
export const getportfolioStatus = (state) => state.adminInfooo.portfolioStatus
export const getportfolioError = (state) => state.adminInfooo.portfolioError;


export const selectBlogList = (state) => state.adminInfooo.blogList
export const getBlogListStatus = (state) => state.adminInfooo.blogListStatus
export const getBlogListError = (state) => state.adminInfooo.blogListoError;

export const getArticle = (state) => state.adminInfooo.article;
export const { fetcharticle } = ResumeSlice.actions



export default ResumeSlice.reducer